/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";

// Material Kit 2 React components
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";

import styles from "assets/scss/emtay.module.scss";

// i18n
import { useLanguage } from "i18n";

function Manifesto() {
  const { t } = useLanguage();

  const bulletPoints = [
    { text: t("manifesto.bullet1"), icon: "person" },
    { text: t("manifesto.bullet2"), icon: "visibility" },
    { text: t("manifesto.bullet3"), icon: "shield" },
    { text: t("manifesto.bullet4"), icon: "sync" },
  ];

  return (
    <MKBox component="section" py={6} sx={{ backgroundColor: "#f8f9fa" }}>
      <Container>
        <Grid container alignItems="center">
          <Grid item xs={12} lg={5}>
            <MKTypography variant="h3" my={1}>
              {t("manifesto.title")}
            </MKTypography>
            <MKTypography variant="body2" color="text" mt={2} mb={4}>
              {t("manifesto.description")}
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 6, lg: 0 } }}>
            <Stack className={styles.servicesBlock}>
              {bulletPoints.map((bullet, index) => (
                <MKBox display="flex" alignItems="center" p={2} key={index}>
                  <MKBox
                    width="3rem"
                    height="3rem"
                    variant="gradient"
                    bgColor="info"
                    color="white"
                    coloredShadow="info"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="xl"
                    className={styles.iconBox}
                    mr={2}
                  >
                    <Icon fontSize="small">{bullet.icon}</Icon>
                  </MKBox>
                  <MKTypography variant="body2" color="text">
                    {bullet.text}
                  </MKTypography>
                </MKBox>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Manifesto;
